import tw from "twin.macro";

export const SectionHeading = tw.h2`text-3xl sm:text-3xl font-light tracking-wide text-center`
export const Subheading = tw.h5`font-light text-secondary-500`
